var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('router-link',{staticClass:"add-spacing",attrs:{"to":{
      name: 'Stat Insp Items Filter',
      query: {
        typeId: this.typeId,
        statusId: this.statusId,
        contractorRegionId: this.contractorRegionId
      }
    }}},[_vm._v(_vm._s(this.statInspItemStatus(this.statusId).name)),_c('strong',[_vm._v("("+_vm._s(_vm.value)+")")])]),_vm._v("  \n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }